import * as React from 'react'

function IconNext(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={69}
      height={40}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M8.365 1.636l23.752 13.678c3.715 2.14 3.715 7.49 0 9.63L8.365 38.616C4.643 40.756 0 38.079 0 33.798V6.448C0 2.166 4.643-.505 8.365 1.636z"
        fill="#219321"
      />
      <path
        d="M37.193 1.636l23.752 13.678c3.715 2.14 3.715 7.49 0 9.63L37.193 38.616c-3.716 2.14-8.365-.537-8.365-4.818V6.448c0-4.282 4.65-6.953 8.365-4.812z"
        fill="#219321"
      />
      <path
        d="M63.117 40a5.446 5.446 0 01-5.453-5.439V5.439C57.664 2.432 60.11 0 63.117 0a5.446 5.446 0 015.454 5.439v29.122c0 3-2.438 5.439-5.454 5.439z"
        fill="#219321"
      />
    </svg>
  )
}

export default IconNext
